import PropTypes from 'prop-types';
import React from 'react';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import Autocomplete from 'react-google-autocomplete';

const AddressInput = ({
  onAddressSubmit,
  required,
  input,
  inputID,
  label,
  type,
  bemClass,
  placeholder,
  autoFocus,
  labelClassName,
  inputClassName,
  meta: { touched, error, warning },
}) => {
  let formErrorClass = `form-group row ${bemClass}`;
  if (touched && error) {
    formErrorClass += ' has-danger';
  } else if (touched && warning) {
    formErrorClass += ' has-warning';
  } else if (touched) {
    formErrorClass += ' has-success';
  }
  return (
    <div className={formErrorClass} id={inputID}>
      <label htmlFor={inputID} className={labelClassName}>
        {label}
        {' '}
        {required && <span className="requiredField">*</span>}
      </label>
      <div className={inputClassName}>
        <Autocomplete
          className={`form-control ${bemClass}__autocomplete`}
          {...input}
          type={type}
          placeholder={placeholder}
          onPlaceSelected={(place) => {
            if (place.formatted_address) {
              onAddressSubmit(place);
            } else {
              onAddressSubmit(place.name);
            }
          }}
          autoFocus={autoFocus}
          data-lpignore="true"
          types={['address']}
          componentRestrictions={{ country: ['ca', 'us'] }}
        />
      </div>

    </div>
  );
};

AddressInput.propTypes = {
  onAddressSubmit: PropTypes.func.isRequired,
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  inputID: PropTypes.string,
  placeholder: PropTypes.string,
  bemClass: PropTypes.string,
  type: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
};

AddressInput.defaultProps = {
  label: null,
  autoFocus: false,
  required: false,
  inputID: null,
  placeholder: null,
  bemClass: null,
  type: 'text',
  labelClassName: 'text-left col-12',
  inputClassName: 'col-12',
};

export default AddressInput;
